import { extensionSlice } from './reducer';

export const { setExtInstalled, setNotExtInstalled, setIOSInstalled, setNotIOSInstalled } = extensionSlice.actions;
